/** Single source for HTTP headers and structured logs (matches deployed x-app-version). */
export const APP_VERSION = process.env.REACT_APP_VERSION || '0.1.0';
export const APP_NAME = 'pegasus-ui';
